import { autoSuggestApi } from 'reduxStore/actions/policyActionDispatcher';

export const AP_WIN_MAX = 365;

export const AUTO_REJECT_RANGE_MAX_BY_ATTRIBUTE = {
	checkin_time: 999999,
	ap_window: AP_WIN_MAX
};

export const POST_BOOKING_APPROVAL_KEYS = {
	DEEMED_APPROVED: 'DA',
	AUTO_REJECT: 'AR',
	APPROVAL_REQUIRED: 'AAR',
	NO_APPROVAL_REQUIRED: 'ANR',
	NOT_ALLOWED: 'NA'
};

export const APPROVAL_RULE_KEYS = {
	/** Approval Required | Approval Required */
	APPROVAL_ALWAYS_REQUIRED: 'APPROVAL_ALWAYS_REQUIRED',
	/** No Approval Required | No Approval Required **/
	NO_APPROVAL_REQUIRED: 'NO_APPROVAL_REQUIRED',
	/** No Approval Required | Approval Required */
	NO_APPROVAL_REQUIRED_WITHIN_POLICY: 'NO_APPROVAL_REQUIRED_WITHIN_POLICY',
	/** IP: Deemed Approved  |  OOP: Deemed Approved */
	POST_BOOKING_DEEMED_APPROVED: 'POST_BOOKING_DEEMED_APPROVED',
	/** IP: Deemed Approved  |  OOP: Approval Required */
	POST_BOOKING_DEEMED_APPROVED_WITHIN_POLICY: 'POST_BOOKING_DEEMED_APPROVED_WITHIN_POLICY',
	/** IP: Deemed Approved  |  OOP: Auto Reject */
	POST_BOOKING_DEEMED_APPROVED_WITH_OOP_AUTO_REJECT: 'POST_BOOKING_DEEMED_APPROVED_WITH_OOP_AUTO_REJECT',
	/** IP: Approval Required  |  OOP: Deemed Approved */
	POST_BOOKING_APPROVAL_WITH_OOP_DEEMED_APPROVED: 'POST_BOOKING_APPROVAL_WITH_OOP_DEEMED_APPROVED',
	/** IP: Approval Required  |  OOP: Auto Reject */
	POST_BOOKING_APPROVAL_WITH_OOP_AUTO_REJECT: 'POST_BOOKING_APPROVAL_WITH_OOP_AUTO_REJECT',
	/** IP: Auto Reject  |  OOP: Auto Reject */
	POST_BOOKING_AUTO_REJECT: 'POST_BOOKING_AUTO_REJECT',
	/** IP: Auto Reject  |  OOP: Deemed Approved */
	POST_BOOKING_AUTO_REJECT_WITH_OOP_DEEMED_APPROVED: 'POST_BOOKING_AUTO_REJECT_WITH_OOP_DEEMED_APPROVED',
	/** IP: Auto Reject  |  OOP: Approval Required */
	POST_BOOKING_AUTO_REJECT_WITHIN_POLICY: 'POST_BOOKING_AUTO_REJECT_WITHIN_POLICY'
};

export const APPROVAL_TYPES = {
	PREBOOK: 'PREBOOK',
	POSTBOOK: 'POSTBOOK'
};

export const POST_BOOKING_APPROVAL_RULE_CONFIG = {
	[APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.DEEMED_APPROVED,
		opVal: POST_BOOKING_APPROVAL_KEYS.DEEMED_APPROVED
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED_WITHIN_POLICY]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.DEEMED_APPROVED,
		opVal: POST_BOOKING_APPROVAL_KEYS.APPROVAL_REQUIRED
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED_WITH_OOP_AUTO_REJECT]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.DEEMED_APPROVED,
		opVal: POST_BOOKING_APPROVAL_KEYS.AUTO_REJECT
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_APPROVAL_WITH_OOP_DEEMED_APPROVED]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.APPROVAL_REQUIRED,
		opVal: POST_BOOKING_APPROVAL_KEYS.DEEMED_APPROVED
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_APPROVAL_WITH_OOP_AUTO_REJECT]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.APPROVAL_REQUIRED,
		opVal: POST_BOOKING_APPROVAL_KEYS.AUTO_REJECT
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_AUTO_REJECT]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.AUTO_REJECT,
		opVal: POST_BOOKING_APPROVAL_KEYS.AUTO_REJECT
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_AUTO_REJECT_WITH_OOP_DEEMED_APPROVED]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.AUTO_REJECT,
		opVal: POST_BOOKING_APPROVAL_KEYS.DEEMED_APPROVED
	},
	[APPROVAL_RULE_KEYS.POST_BOOKING_AUTO_REJECT_WITHIN_POLICY]: {
		ipVal: POST_BOOKING_APPROVAL_KEYS.AUTO_REJECT,
		opVal: POST_BOOKING_APPROVAL_KEYS.APPROVAL_REQUIRED
	}
};

export const APPROVAL_CONFIG = {
	'ANRNA': APPROVAL_RULE_KEYS.NO_APPROVAL_REQUIRED,
	'ANRANR': APPROVAL_RULE_KEYS.NO_APPROVAL_REQUIRED,
	'ANRAAR': APPROVAL_RULE_KEYS.NO_APPROVAL_REQUIRED_WITHIN_POLICY,
	'AARNA': APPROVAL_RULE_KEYS.APPROVAL_ALWAYS_REQUIRED,
	'AARAAR': APPROVAL_RULE_KEYS.APPROVAL_ALWAYS_REQUIRED,
	'AAR': APPROVAL_RULE_KEYS.APPROVAL_ALWAYS_REQUIRED,
	'ANR': APPROVAL_RULE_KEYS.NO_APPROVAL_REQUIRED,
	/** IP: Deemed Approved CONFIGS */
	'DADA': APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED,
	'DAAAR': APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED_WITHIN_POLICY,
	'DAAR': APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED_WITH_OOP_AUTO_REJECT,
	'DANA': APPROVAL_RULE_KEYS.POST_BOOKING_DEEMED_APPROVED,
	'AARDA': APPROVAL_RULE_KEYS.POST_BOOKING_APPROVAL_WITH_OOP_DEEMED_APPROVED,
	'AARAR': APPROVAL_RULE_KEYS.POST_BOOKING_APPROVAL_WITH_OOP_AUTO_REJECT,
	'ARAR': APPROVAL_RULE_KEYS.POST_BOOKING_AUTO_REJECT,
	'ARDA': APPROVAL_RULE_KEYS.POST_BOOKING_AUTO_REJECT_WITH_OOP_DEEMED_APPROVED,
	'ARAAR': APPROVAL_RULE_KEYS.POST_BOOKING_AUTO_REJECT_WITHIN_POLICY
};

export const searchType = {
	city: 'city',
	country: 'country',
	hotel: 'hotel',
	state: 'state'
};

export const apiFormat = {
	[searchType.city]: {
		label: 'cityName',
		value: 'cityCode'
	},
	[searchType.country]: {
		label: 'countryName',
		value: 'countryCode'
	},
	[searchType.hotel]: {
		label: 'displayName',
		value: 'id'
	},
	[searchType.state]: {
		label: 'name',
		value: 'id'
	}
};

export const lob_icon_map = {
	DOM_FLIGHTS: {
		icon: 'flightIcon',
		disabledClass: 'flightGrayIcon',
		policyKey: 'DOM_FLIGHT',
		blockLob: 'FLIGHTS',
		apiKey: 'dom_flight'
	},
	DOM_HOTELS: { icon: 'hotelIcon',
		disabledClass: 'hotelGrayIcon',
		policyKey: 'HOTEL',
		blockLob: 'HOTEL',
		apiKey: 'dom_htl',
		searchType: searchType.city,
		tierMapKey: 'dom_mapping' },
	AIRPORT_CABS: {
		icon: 'cabIcon',
		disabledClass: 'cabGrayIcon',
		policyKey: 'AIRPORT_CABS',
		blockLob: 'AIRPORT_CABS',
		isInrOnly: true,
		apiKey: 'airport_cab'
	},
	OUTSTATION_CABS: {
		icon: 'cabIcon',
		disabledClass: 'cabGrayIcon',
		policyKey: 'OUTSTATION_CABS',
		blockLob: 'OUTSTATION_CABS',
		isInrOnly: true,
		apiKey: 'outstation_cab'
	},
	BUS: {
		icon: 'busIcon',
		disabledClass: 'busGrayIcon',
		policyKey: 'BUS',
		blockLob: 'BUS',
		isInrOnly: true,
		apiKey: 'bus'
	},
	INTL_FLIGHTS: {
		icon: 'flightIcon',
		disabledClass: 'flightGrayIcon',
		policyKey: 'INTL_FLIGHT',
		blockLob: 'INTL_FLIGHTS',
		apiKey: 'intl_flight'
	},
	INTL_HOTELS: {
		icon: 'hotelIcon',
		disabledClass: 'hotelGrayIcon',
		policyKey: 'INTL_HOTEL',
		blockLob: 'INTL_HOTEL',
		apiKey: 'intl_htl',
		searchType: searchType.country,
		tierMapKey: 'intl_mapping'
	},
	TRAIN: {
		icon: 'trainIcon',
		disabledClass: 'trainGrayIcon',
		policyKey: 'TRAIN',
		blockLob: 'TRAIN',
		apiKey: 'dom_flight'
	},
	RENTAL_CABS: {
		icon: 'cabIcon',
		disabledClass: 'cabGrayIcon',
		policyKey: 'RENTAL_CABS',
		blockLob: 'RENTAL_CABS',
		isInrOnly: true,
		apiKey: 'rental_cab'
	},
	REQUISITION: {
		icon: 'reportActiveIcon',
		disabledClass: 'reportIcon',
		policyKey: 'REQUISITION',
		blockLob: 'REQUISITION',
		apiKey: 'requisition'
	},
	GIFT_CARDS: {
		icon: 'giftCardIcon',
		disabledClass: 'giftCardGrayIcon',
		policyKey: 'GIFT_CARDS',
		blockLob: 'GIFT_CARDS',
		apiKey: 'gift_cards'
	},
	MICE: {
		icon: 'miceIcon',
		disabledClass: 'miceGrayIcon',
		policyKey: 'MICE',
		blockLob: 'MICE',
		apiKey: 'mice'
	},
	VISA: {
		icon: 'visaIcon',
		disabledClass: 'visaIconGray',
		policyKey: 'VISA',
		blockLob: 'VISA',
		apiKey: 'visa'
	},
	MEALS: {
		icon: 'mealIcon',
		disabledClass: 'mealGrayIcon',
		policyKey: 'MEALS',
		blockLob: 'MEALS',
		apiKey: 'meals'
	},
	INSURANCE: {
		icon: 'insuranceIcon',
		disabledClass: 'insuranceIconGray',
		policyKey: 'INSURANCE',
		blockLob: 'INSURANCE',
		apiKey: 'insurance'
	}
};

export const fkey_map_omniture = {
	'emp_elg_ip': 'EmployeeEligibility',
	'block': 'EmployeeEligibility',
	'display': 'CheaperFare',
	'f_type_ip': 'fare_type',
	'in_pol_aprvl_ip': 'approval_IP',
	'oop_aprvl_ip': 'approval_OOP',
	'wlt_optns_ip': 'Wallet',
	'in_pol_def_mgr_ip': 'manager_IP',
	'oop_def_mgr_ip': 'manager_OOP',
	'cond_aprvl_attr_ip': 'Conditional',
	'cond_aprvl_range_ip': 'Conditional',
	'cond_aprvl_val_ip': 'Conditional',
	'cond_aprvl_mgr_ip': 'Conditional',
	'skp_aprvl_1_ip': 'skipapproval',
	'tier_city': 'Tier_n_city',
	'tier_price': 'Tier_n_budget',
	'budget_pay': 'Budget',
	'flight_price': 'Budget',
	'cab_price_ip': 'Budget',
	'htl_price': 'Budget',
	'flt_price_ip': 'Budget',
	'bus_price_ip': 'Budget',
	'cab_class_ip': 'cabClass',
	'cabin_ip': 'CabinType',
	'a_cab': 'Ancillary',
	'a_seats': 'Ancillary',
	'a_meal': 'Ancillary',
	'a_bag': 'Ancillary',
	'add_tier': 'Tier',
	'add_conditional_approval': 'Conditional'
};

export const CONSTANTS = {
	ORG_ID_URL_PARAM: 'orgId',
	ERROR: 'We are facing some technical issue!',
	DETAIL_TYPE: 'policy'
};

export const mandatoryFields = [
	'approval', 'payment_options'
];

export const LOB_CONSTANTS = {
	DOM_HOTELS: 'DOM_HOTELS',
	INTL_HOTELS: 'INTL_HOTELS',
	DOM_FLIGHTS: 'DOM_FLIGHTS',
	INTL_FLIGHTS: 'INTL_FLIGHTS',
	AIRPORT_CABS: 'AIRPORT_CABS',
	OUTSTATION_CABS: 'OUTSTATION_CABS',
	TRAIN: 'TRAIN',
	RENTAL_CABS: 'RENTAL_CABS',
	REQUISITION: 'REQUISITION',
	MICE: 'MICE',
	GIFT_CARDS: 'GIFT_CARDS'
};

/** REQUISITION trip vs service level — UI fkeys, checkbox keys, API payload keys */
export const REQUISITION_LOB_ATTRKEY_TO_PREFIX = {
	HOTEL: 'htl',
	FLIGHT: 'flt',
	CABS: 'cab',
	BUS: 'bus',
	TRAIN: 'train',
	VISA: 'visa',
	FOREX: 'forex',
	ADVANCE: 'advances'
};

export const REQUISITION_LOB_FIELD_SUFFIXES = ['_header', '_tvl_option', '_book_cmp'];

export const REQUISITION_FKEY_PREFIX_TO_LOB = Object.fromEntries(
	Object.entries(REQUISITION_LOB_ATTRKEY_TO_PREFIX).map(([lob, prefix]) => [prefix, lob])
);

export const TRF_FLOW_API_TO_UI = {
	TRIP_LEVEL: 'REQ_TRIP_LEVEL',
	SERVICE_LEVEL: 'REQ_SERVICE_LEVEL'
};

export const TRF_FLOW_UI_TO_API = {
	REQ_TRIP_LEVEL: 'TRIP_LEVEL',
	REQ_SERVICE_LEVEL: 'SERVICE_LEVEL'
};

export const PLATFORMS = [
	'ANDROID', 'IOS', 'DESKTOP'
];

export const APPROVAL_KEY_CONFIG = {
	[APPROVAL_RULE_KEYS.APPROVAL_ALWAYS_REQUIRED]: POST_BOOKING_APPROVAL_KEYS.APPROVAL_REQUIRED,
	[APPROVAL_RULE_KEYS.NO_APPROVAL_REQUIRED]: POST_BOOKING_APPROVAL_KEYS.NO_APPROVAL_REQUIRED
};

export const multiplierTxts = {
	footer: 'Setting up a multiplying factor less than 1 helps you optimize your organization’s hotel budget when there are more than one employees travelling!',
	noValFooter: 'Type in a number greater than 0 and less than equal to 1 to see how your organization’s hotel budget gets optimized when there are more than one employee travelling!'
};

export const toolTipConfig = {
	width: '610px',
	posTop: '-20px',
	posLeft: '16px',
	left: '75%',
	transform: 'translate(-75%,-100%)',
	bg_color: '#fff',
	color: '#000',
	zIndex: '2',
	padding: '0',
	boxShadow: '0 3px 10px 0 rgb(0 0 0 / 10%)'
};

export const autoSuggestConfigs = {
	[lob_icon_map['DOM_HOTELS'].tierMapKey]: async (val, defaultOptions)=>await autoSuggestApi({ q: val, t: searchType.city }, apiFormat[searchType.city], defaultOptions),
	[lob_icon_map['INTL_HOTELS'].tierMapKey]: async (val, defaultOptions)=>await autoSuggestApi({ q: val, t: searchType.country }, apiFormat[searchType.country], defaultOptions),
	'state': async (val, defaultOptions)=>await autoSuggestApi({ q: val, t: searchType.state }, apiFormat[searchType.state], defaultOptions),
	'hotel': async (val, defaultOptions)=>await autoSuggestApi({ q: val, t: searchType.hotel }, apiFormat[searchType.hotel], defaultOptions)
};

export const SHARED_CABS_CONFIG = {
	SUBFIELD_DISABLE: ['linked_attributes.0_class_price', 'linked_attributes.1_class_price', 'linked_attributes.2_class_price', 'linked_attributes.3_class_price']
};

export const ERROR_AUTO_CLOSE_SECONDS = 3;
export const MAX_MANDATORY_FILTERS = 2;
export const MANDATORY_FILTERS_LIMIT_ERROR_MESSAGE = `You can select a maximum of ${MAX_MANDATORY_FILTERS} mandatory filters (Exclude OOP, Free Breakfast, MyBiz Assured).`;
